import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useStore } from 'react-redux'
import Select from 'react-select'
import { updateSupplierPaymentInfo, addSupplierHistory } from '../../../../redux/actions/vendor'
import CheckboxComponent from '../../../CommonComponents/CheckboxComponent'
import { checkZip, convertAddress, generateCheckAcceptanceChangeLog, getParsedAddress, isDiffTwoObj } from '../../../../services/helper'
import ThreeStateToggleButton from '../../../CommonComponents/ThreeStateToggleButton'
import { parseFullAddress } from '../../../../redux/actions/upload'
import { Loader } from 'rsuite'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'

const SupplyCheckAcceptance = ({ checkColumns, masterSupplierId, onUpdateCompletenessScore = () => { }, onInfoChange }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    vendor: {
      masterSupplierDetails,
      isLoadingMasterDetail,
    }
  } = store

  const paymentTermsOptions = [...Array(91)].map((_, i) => i);
  const [showPaymentTerms, setShowPaymentTerms] = useState(false)
  const [checkAddressFromCompany, setCheckAddressFromCompany] = useState(false)
  const [checkInfo, setCheckInfo] = useState({})
  const [supplierOldCardInfo, setSupplierOldCardInfo] = useState({})
  const [cashDiscountType, setCashDiscountType] = useState({
    label: '',
    value: ''
  })
  const [isParsingAddress, setIsParsingAddress] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleTogglePayment = (checked) => {
    setCheckInfo({
      ...checkInfo,
      isAcceptCheckPayments: checked
    })
    onInfoChange(true)
  }

  const handleToggleDiscount = (checked) => {
    setCheckInfo({
      ...checkInfo,
      isAcceptCashDiscount: checked
    })
    onInfoChange(true)
  }
  const handleToggleAddress = (checked) => {
    const tmpCheckInfo = JSON?.parse(JSON?.stringify(checkInfo))
    // tmpCheckInfo.isMatchVendorAddress = checked
    tmpCheckInfo.isAcceptPaymentAddressFromCompanyAddress = checked
    if (checked) {
      tmpCheckInfo.checkAddress1 = masterSupplierDetails?.baseInfo?.address1 || ''
      tmpCheckInfo.checkAddress2 = masterSupplierDetails?.baseInfo?.address2 || ''
      tmpCheckInfo.checkCity = masterSupplierDetails?.baseInfo?.city || ''
      tmpCheckInfo.checkState = masterSupplierDetails?.baseInfo?.state || ''
      tmpCheckInfo.checkZip = masterSupplierDetails?.baseInfo?.zip || ''
      tmpCheckInfo.checkCountry = masterSupplierDetails?.baseInfo?.country || ''
    }
    setCheckInfo({ ...tmpCheckInfo })
    setCheckAddressFromCompany(checked)
    onInfoChange(true)
  }

  const handleChangeCheckInfo = (colname, value, type = '') => {
    var discountValue = ''
    if (type !== 'discounttype' && type !== '') {
      var temp = "";
      temp = parseInt(value.replace(/\D/g, ''));
      temp = isNaN(temp) ? '' : temp
      value = temp ? ((temp) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
    }

    if (type === 'percent') {
      if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
        setCheckInfo({
          ...checkInfo,
          [colname]: value
        })
      } else {
        setCheckInfo({
          ...checkInfo,
          [colname]: value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
        })
      }
      onInfoChange(true)
      return
    }
    if (type === 'discounttype') {
      discountValue = value?.value === 'Percentage' ? checkInfo?.cashDiscountValue && checkInfo?.cashDiscountValue?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
        parseInt(checkInfo?.cashDiscountValue.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
        : ''
        : checkInfo?.cashDiscountValue

      setCheckInfo({
        ...checkInfo,
        cashDiscountValue: discountValue,
        [colname]: value?.value
      })
      setCashDiscountType(value)
      onInfoChange(true)
      return
    }
    setCheckInfo({
      ...checkInfo,
      [colname]: value
    })
    onInfoChange(true)
  }

  const handleClickCancel = () => {
    setInitialCheckInfo(checkColumns, masterSupplierDetails)
    onInfoChange(false)
  }

  const handleClickSave = async () => {
    setIsLoading(true)
    if (checkInfo?.checkAddress1) {
      let address = convertAddress(checkInfo?.checkAddress1)
      checkInfo.checkAddress1 = address
    }

    if (checkInfo?.checkZip) {
      let validZip = checkZip(checkInfo?.checkZip)
      if (!validZip) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Zip',
        })
        setIsLoading(false)
        return
      }
    }

    let isPaymentUpdated = isDiffTwoObj(checkInfo, supplierOldCardInfo?.paymentInfo)
    await dispatch(
      await updateSupplierPaymentInfo({
        masterSupplierId,
        paymentId: masterSupplierDetails?.paymentInfo?.id,
        paymentData: {
          ...masterSupplierDetails?.paymentInfo,
          ...checkInfo,
        },
        isPaymentUpdated
      })
    ).then(async () => {
      await addCheckAcceptanceHistory()
      onUpdateCompletenessScore(masterSupplierDetails?.baseInfo?.id)
      onInfoChange(false)
      setIsLoading(false)
    })
  }

  const setInitialCheckInfo = useCallback((columns, supplierDetails) => {
    setCheckAddressFromCompany(supplierDetails?.paymentInfo?.isAcceptPaymentAddressFromCompanyAddress || false)
    setShowPaymentTerms(supplierDetails?.paymentInfo?.isAcceptCashPaymentTerms === null ? null : supplierDetails?.paymentInfo?.isAcceptCashPaymentTerms)
    setCashDiscountType({
      label: !supplierDetails?.paymentInfo?.cashDiscountType ? '%' : supplierDetails?.paymentInfo?.cashDiscountType === 'Percentage' ? '%' : '$',
      value: supplierDetails?.paymentInfo?.cashDiscountType || 'Percentage',
    })
    const tmpCheckInfo = {}
    columns.forEach(column => {
      if (column.datatype === 'boolean') {
        tmpCheckInfo[column.name] = supplierDetails?.paymentInfo?.[column.name] === null ? null : supplierDetails?.paymentInfo?.[column.name]
      } else {
        tmpCheckInfo[column.name] = supplierDetails?.paymentInfo?.[column.name] || column.defaultValue
      }
    })
    setCheckInfo(tmpCheckInfo)
    setSupplierOldCardInfo(supplierDetails)
  }, [])

  useEffect(() => {
    if (isLoadingMasterDetail) {
      return
    }
    if ((!masterSupplierDetails || !masterSupplierDetails.paymentInfo)) {
      return
    }
    setInitialCheckInfo(checkColumns, masterSupplierDetails)
  }, [masterSupplierDetails, isLoadingMasterDetail, setInitialCheckInfo])

  const handleTogglePaymentTerms = (checked) => {
    setCheckInfo({
      ...checkInfo,
      isAcceptCashPaymentTerms: checked
    })
    setShowPaymentTerms(checked)
    onInfoChange(true)
  }

  const addCheckAcceptanceHistory = async () => {
    const changeLogNotes = generateCheckAcceptanceChangeLog(supplierOldCardInfo, checkInfo)
    if (changeLogNotes !== '') {
      await dispatch(
        await addSupplierHistory({
          supplierId: masterSupplierDetails?.baseInfo?.id,
          note: changeLogNotes,
          noteType: 'changelog'
        })
      )
    }
  }

  const parseAddress = async () => {
    if (checkInfo?.checkAddress1) {
      try {
        setIsParsingAddress(true)
        const addressResult = await dispatch(parseFullAddress(checkInfo?.checkAddress1))
        const parsedResult = getParsedAddress(addressResult)
        setCheckInfo({
          ...checkInfo,
          'checkAddress1': parsedResult?.add1 ? parsedResult?.add1 : '',
          'checkAddress2': parsedResult?.add2 ? parsedResult?.add2 : '',
          'checkCity': parsedResult?.city ? parsedResult?.city?.value : '',
          'checkState': parsedResult?.state ? parsedResult?.state?.value : '',
          'checkCountry': parsedResult?.country ? parsedResult?.country?.value : '',
          'checkZip': parsedResult?.zip ? parsedResult?.zip?.value : ''
        })
        setIsParsingAddress(false)
      } catch (err) {
        setIsParsingAddress(false)
      }
    }
  }

  return (
    <div className="card supply-check-acceptance mt-0 pt-0 pb-0">
      {isLoading && <LoaderComponent />}
      <div className="card-header flex-column flex-sm-row align-items-start align-items-sm-center pt-2 pb-2 h-auto">
        <h3 className='fw-bold mb-0'>Check Acceptance</h3>
        <div className="tool d-flex gap-3">
          <button type="button" className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100" onClick={handleClickCancel}>Cancel</button>
          <button type="button" className="card-edit-button ps-3 pe-3 ps-sm-4 pe-sm-4 width-100" onClick={handleClickSave}>Save</button>
        </div>
      </div>
      <div className="card-content">
        <div className="item pb-0">
          <h4 className='fw-bold text-black toggle-item-text mb-0'>Do they accept Check Payments?</h4>
          <ThreeStateToggleButton onChange={(event) => handleTogglePayment(event)} checked={checkInfo.isAcceptCheckPayments} />
        </div>
        {
          checkInfo.isAcceptCheckPayments && (
            <>
              <div className='item pt-3'>
                <CheckboxComponent
                  label='Check payment address varies from company address'
                  onChange={handleToggleAddress}
                  checked={checkAddressFromCompany}
                />
              </div>
              <div className="item h-100">
                <h4 className="item-name mb-0">Address Line1:</h4>
                <input
                  type="text"
                  className="search-input"
                  disabled={!checkAddressFromCompany}
                  value={checkInfo?.checkAddress1}
                  onChange={(e) => handleChangeCheckInfo('checkAddress1', e.target.value)}
                />
                {checkInfo?.checkAddress1 && (
                  <div className="position-relative text-center ms-3" style={{ height: '48px' }}>
                    {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                    <button
                      type="button"
                      className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 fs-6 bg-dark-blue rounded text-white`}
                      onClick={parseAddress}
                    >
                      Parse Address
                    </button>
                  </div>
                )}
              </div>
              <div className="item">
                <h4 className="item-name mb-0">Address Line2:</h4>
                <input
                  type="text"
                  className="search-input"
                  disabled={!checkAddressFromCompany}
                  value={checkInfo?.checkAddress2}
                  onChange={(e) => handleChangeCheckInfo('checkAddress2', e.target.value)}
                />
              </div>
              <div className="item">
                <h4 className="item-name mb-0">City:</h4>
                <input
                  type="text"
                  className="search-input"
                  disabled={!checkAddressFromCompany}
                  value={checkInfo?.checkCity}
                  onChange={(e) => handleChangeCheckInfo('checkCity', e.target.value)}
                />
              </div>
              <div className="item">
                <h4 className="item-name mb-0">State:</h4>
                <input
                  type="text"
                  className="search-input"
                  disabled={!checkAddressFromCompany}
                  value={checkInfo?.checkState}
                  onChange={(e) => handleChangeCheckInfo('checkState', e.target.value)}
                />
              </div>
              <div className="item">
                <h4 className="item-name mb-0">Country:</h4>
                <input
                  type="text"
                  className="search-input"
                  disabled={!checkAddressFromCompany}
                  value={checkInfo?.checkCountry}
                  onChange={(e) => handleChangeCheckInfo('checkCountry', e.target.value)}
                />
              </div>
              <div className="item">
                <h4 className="item-name mb-0">Zip:</h4>
                <input
                  type="text"
                  className="search-input check-zip-input"
                  disabled={!checkAddressFromCompany}
                  value={checkInfo?.checkZip}
                  onChange={(e) => handleChangeCheckInfo('checkZip', e.target.value)}
                />
              </div>
              <div className="item">
                <h4 className='fw-bold text-black toggle-item-text mb-0'>Cash Payment Terms</h4>
                <ThreeStateToggleButton onChange={handleTogglePaymentTerms} checked={showPaymentTerms} />
              </div>

              {
                showPaymentTerms && (
                  <div className="item payment-terms">
                    <div className='d-flex align-items-sm-center align-items-start w-100 flex-column flex-sm-row'>
                      <h4 className='text-black fw-normal mb-0'>Payment Terms:</h4>
                      <Select
                        className="cash-payment-terms-selector ms-0 ms-sm-auto h4 mb-0"
                        placeholder="Select..."
                        options={
                          paymentTermsOptions.map((element) => (
                            {
                              label: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days'),
                              value: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days')
                            }
                          ))
                        }
                        value={{
                          label: checkInfo?.cashPaymentTermsValue || '',
                          value: checkInfo?.cashPaymentTermsValue || '',
                        }}
                        onChange={item => handleChangeCheckInfo('cashPaymentTermsValue', item.value)}
                      />
                    </div>
                  </div>
                )
              }

              <div className="item">
                <h4 className='fw-bold text-black toggle-item-text mb-0'>Do they offer cash Discount?</h4>
                <ThreeStateToggleButton onChange={handleToggleDiscount} checked={checkInfo.isAcceptCashDiscount} />
              </div>
              {
                checkInfo.isAcceptCashDiscount && (
                  <>
                    <div className="item cash-discount d-flex flex-column flex-sm-row align-items-start align-items-sm-center pb-0">
                      <h4 className='text-black fw-normal mb-0'> Cash Discount: </h4>
                      <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                        <div className='d-flex'>
                          <div className='flex processing-fee-dropdown-child flex-grow-1'>
                            <Select
                              menuMaxHeight={48}
                              className="processing-fee-dropdown h4 mb-0"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: 'Dollar',
                                  },
                                  {
                                    label: '%',
                                    value: 'Percentage',
                                  },
                                ]
                              }
                              value={cashDiscountType}
                              onChange={item => handleChangeCheckInfo('cashDiscountType', item, 'discounttype')}
                            />
                            <input
                              type="text"
                              className="search-input cash-discount-value-input"
                              value={checkInfo?.cashDiscountValue || ''}
                              onChange={(e) => handleChangeCheckInfo('cashDiscountValue', e.target.value, cashDiscountType?.value === 'Dollar' ? 'currency' : 'percent')}
                              placeholder={cashDiscountType?.value === 'Dollar' ? '1,234.00' : '12.50'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )
              }
            </>
          )
        }
      </div>
    </div>
  )
}

export default SupplyCheckAcceptance